import styled from 'styled-components';

const SectionHeaderWrapper = styled.div`
  margin-top: 38px;
`;

const StyledSectionHeaderDivider = styled.div`
  width: 100%;
  height: 1px;
  border: solid 1px rgba(8, 10, 37, 0.1);
  margin-bottom: 19px;
`;

const StyledSectionTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  color: #101938;
  margin-bottom: 10.5px;

  ::before {
    content: '${(props) => props.title}';
  }
`;

export function DetailsVisHeader({ title }) {
  return (
    <SectionHeaderWrapper>
      <StyledSectionTitle title={title} />
      <StyledSectionHeaderDivider />
    </SectionHeaderWrapper>
  );
}
